const WalkingOnSunshine = [
	'[Verse 1]',
	"I used to think maybe you love me, now baby I'm sure",
	"And I just can't wait till the day when you knock on my door",
	'Now every time I go for the mailbox gotta hold myself down',
	"Cuz I just can't wait till you write me you're comin' around",
	'',
	'[Chorus]',
	"And I'm walking on sunshine... Whoah!",
	"I'm walking on sunshine... Whoah!",
	"I'm walking on sunshine... Whoah!",
	'',
	"And don't it feel good! HEY! Alright now!",
	"And don't it feel good! HEY! Yeah!",
	'',
	'[Verse 2]',
	"I used to think maybe you love me, now I know that it's true",
	"And I don't want to spend my whole life, just a waitin' for you",
	"Now I don't want you back for the weekend, not back for a day, no no no",
	'I said baby I just want you back, and I want you to stay, (Oh yeah now!)',
	'',
	'[Chorus]',
	"I'm walking on sunshine... Whoah!",
	"I'm walking on sunshine... Whoah!",
	"I'm walking on sunshine... Whoah! And it's time to feel good!",
	'',
	"Hey! Alright now, and it's time to feel good! Yeah, oh yeah now",
	"And it's time to feel good",
	'',
	'Walking on sunshine',
	'Walking on sunshine',
	"I feel alive, I feel the love, I feel a love that's really real!",
	"I feel alive, I feel the love, I feel a love that's really real!",
	'',
	"I'm on sunshine baby, oh! oh yeah",
	"I'm on sunshine baby, oh!",
	'',
	'[Chorus]',
	"I'm walking on sunshine... Whoah!",
	"I'm walking on sunshine... Whoah!",
	"I'm walking on sunshine... Whoah! And it's time to feel good!",
	'',
	"Hey! Alright now, and it's time to feel good!",
	"I say it, I say it, I say it again now, and it's time to feel good!",
	"Oh yeah now, and it's time to feel good!",
	'Now time,time,time,time,time and time to feel good!',
	'I say it, I say it, I say it again now, and time to feel good',
	'Now time,time,time,time,time and time to feel good!',
	'Now tell me, tell me, tell me again now and time to feel good!',
	'Oh yeah now, and time to feel good!',
	"Now don't it feel good, don't it feel good, now, time to feel good!",
	'Oh yeah, oh yeah, oh yeah, oh yeah, yeah, yeah',
];

export default WalkingOnSunshine;
